import { Component, OnInit,Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormArray } from "@angular/forms";
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { environment } from "../../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-college-application-create",
  templateUrl: "./college-application-create.component.html",
  styleUrls: ["./college-application-create.component.scss"]
})
export class CollegeApplicationCreateComponent implements OnInit {
    @Input() record: any;          // ✅ data for edit
  @Input() collegeId: string;    // ✅ college id from parent
  @Output() formSaved = new EventEmitter<void>();  // ✅ notify parent
  @Output() cancel = new EventEmitter<void>();     // ✅ cancel event
  public applicationForm: FormGroup;
    
  submitted = false;
  message = null;
  class = null;
  action = null;
  isShown: boolean = false;
  cities = [];
  branches = [];
  collegeEntranceExams = [];
  colleges = [];
  applicantStatuses = ['Pending', 'Selected', 'Rejected', 'In Review'];
  collegeStatuses = ['Applied', 'Shortlisted', 'Admitted', 'Rejected'];
  genders = ['Male', 'Female', 'Other'];

  constructor(
    private activatedRoute: ActivatedRoute,

    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit() {
    this.initializeForm();
    this.loadDropdownData();
    
    this.activatedRoute.params.subscribe((params) => {
      const id = params["id"];
      if (id) {
        this.loadApplicationData(id);
        this.action = "Update";
      } else {
        this.action = "Submit";
      }
    });
    
    

  }

  initializeForm() {
    this.applicationForm = this.formBuilder.group({
      _id: [''],
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      userid: [''],
      courseinterested: ['', Validators.required],
      applieddate: ['', Validators.required],
      status: [false],
      collegestatus: [false],
      applicantstatus: ['Pending'],
      phone: ['', [Validators.required, Validators.pattern(/^[0-9]{10,15}$/)]],
      city: ['', Validators.required],
      branch: ['', Validators.required],
      description: [''],
      entrance: [''],
      entranceexam: this.formBuilder.array([]),
      collegeinfo: this.formBuilder.array([]),
      planningyourstudies: [''],
      comments: [''],
      gender: ['']
    });
    if (this.record) {
      this.action = "Update";
      this.applicationForm.patchValue(this.record);
    } else {
      this.action = "Submit";
      this.applicationForm.patchValue({ college: this.collegeId });
    }

    // Add at least one entrance exam and college info by default
    this.addEntranceExam();
    this.addCollegeInfo();
    
  }
  

  get entranceExams(): FormArray {
    return this.applicationForm.get('entranceexam') as FormArray;
  }

  get collegeInfos(): FormArray {
    return this.applicationForm.get('collegeinfo') as FormArray;
  }

  createEntranceExam(): FormGroup {
    return this.formBuilder.group({
      entranceexamid: ['', Validators.required],
      score: ['', [Validators.required, Validators.min(0)]]
    });
  }

  createCollegeInfo(): FormGroup {
    return this.formBuilder.group({
      college: ['', Validators.required],
      status: ['Applied']
    });
  }

  addEntranceExam(): void {
    this.entranceExams.push(this.createEntranceExam());
  }

  addCollegeInfo(): void {
    this.collegeInfos.push(this.createCollegeInfo());
  }

  removeEntranceExam(index: number): void {
    this.entranceExams.removeAt(index);
  }

  removeCollegeInfo(index: number): void {
    this.collegeInfos.removeAt(index);
  }

  loadDropdownData() {
    // Load cities
    this.http.get<any>(`${environment.apiUrl}/city/`).subscribe(
      (data) => {
        this.cities = data.results || data;
      },
      (error) => {
        console.error('Error loading cities:', error);
      }
    );

    // Load branches
    this.http.get<any>(`${environment.apiUrl}/branch/`).subscribe(
      (data) => {
        this.branches = data.results || data;
      },
      (error) => {
        console.error('Error loading branches:', error);
      }
    );

    // Load entrance exams
    this.http.get<any>(`${environment.apiUrl}/collegeentranceexamdetails/`).subscribe(
      (data) => {
        this.collegeEntranceExams = data.results || data;
      },
      (error) => {
        console.error('Error loading entrance exams:', error);
      }
    );

    // Load colleges
    this.http.get<any>(`${environment.apiUrl}/college/`).subscribe(
      (data) => {
        this.colleges = data.results || data;
      },
      (error) => {
        console.error('Error loading colleges:', error);
      }
    );
  }

  loadApplicationData(id: string) {
    this.http.get<any>(`${environment.apiUrl}/collegeapplication/${id}`).subscribe(
      (data) => {
        if (data) {
          // Patch main form values
          this.applicationForm.patchValue({
            _id: data._id,
            name: data.name,
            email: data.email,
            userid: data.userid,
            courseinterested: data.courseinterested,
            applieddate: data.applieddate ? new Date(data.applieddate).toISOString().substring(0, 10) : '',
            status: data.status,
            collegestatus: data.collegestatus,
            applicantstatus: data.applicantstatus || 'Pending',
            phone: data.phone,
            city: data.city,
            branch: data.branch,
            description: data.description,
            entrance: data.entrance,
            planningyourstudies: data.planningyourstudies,
            comments: data.comments,
            gender: data.gender
          });

          // Patch entrance exams
          if (data.entranceexam && data.entranceexam.length) {
            this.entranceExams.clear();
            data.entranceexam.forEach(exam => {
              this.entranceExams.push(this.formBuilder.group({
                entranceexamid: [exam.entranceexamid, Validators.required],
                score: [exam.score, [Validators.required, Validators.min(0)]]
              }));
            });
          }

          // Patch college info
          if (data.collegeinfo && data.collegeinfo.length) {
            this.collegeInfos.clear();
            data.collegeinfo.forEach(info => {
              this.collegeInfos.push(this.formBuilder.group({
                college: [info.college, Validators.required],
                status: [info.status || 'Applied']
              }));
            });
          }
        }
      },
      (error) => {
        console.error('Error loading application data:', error);
      }
    );
  }

  get f() {
    return this.applicationForm.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.applicationForm.invalid) {
      return;
    }

    const formData = this.applicationForm.value;

    if (this.action === "Submit") {
      this.http.post<any>(`${environment.apiUrl}/collegeapplication/`, formData).subscribe(
        (res) => {
          this.handleResponse(res, 'Successfully Added');
            this.formSaved.emit();   // ✅ emit on success
        },
        (error) => {
          this.handleError(error);
        }
      );
    } else {
      const id = this.applicationForm.get('_id').value;
      this.http.patch<any>(`${environment.apiUrl}/collegeapplication/${id}`, formData).subscribe(
        (res) => {
          this.handleResponse(res, 'Successfully Updated');
        },
        (error) => {
          this.handleError(error);
        }
      );
    }
  }

  handleResponse(res: any, successMessage: string) {
    if (res.message === "Logged Out!") {
      this.router.navigateByUrl("/auth/login");
      return;
    }
    
    if (res.status === "500") {
      this.message = res.message;
      this.class = "btn-primary rounded px-1 py-1";
    } else {
      this.message = successMessage;
      this.class = "btn-success rounded px-1 py-1";
      this.router.navigateByUrl("/college-details/college-application-list");
    }
  }

  handleError(error: HttpErrorResponse) {
    if (error.error instanceof Error) {
      console.log("Client-side error occurred.");
    } else {
      console.log("Server-side error occurred.");
    }
    this.message = "An error occurred. Please try again.";
    this.class = "btn-danger rounded px-1 py-1";
  }
   onCancel() {
  if (this.cancel.observers.length > 0) {
    // 🔹 Case 1: Opened inside modal (popup)
    this.cancel.emit();  
  } else {
    // 🔹 Case 2: Opened as a standalone routed page
    this.router.navigateByUrl("/college-details/college-application-list");
  }
}

}